export * from '../core/pipes/data.pipe'
export * from '../core/pipes/real.pipe'
export * from '../core/pipes/mes.pipe'


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/lib/pipe.ts
 **/